import AppDataService from "./AppDataService";

export default class OrderService {
  static async getOrderList(data) {
    const queryParams = [
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      data?.searchKey ? `searchValue=${data.searchKey}` : "",
      data?.orderStatus ? `orderStatus=${data.orderStatus}` : "",
      data?.status ? `status=${data.status}` : "",
      data?.inventoryType ? `inventoryType=${data.inventoryType}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`admin/orders${queryString}`);
  }

  static async updateOrderStatus(id, data) {
    return await AppDataService.patch(`admin/orders/${id}`, data);
  }
}
